export interface SessionsImagesManagmentProps {
  sheetId: string;
  onClose: () => void;
  onCancel: () => void;
  isConfigured: boolean;
}

export interface DownloadedFile {
  sheetPageId: string;
  displayName: string;
  pageNumber: number;
}

export interface ExamSheetFile extends DownloadedFile {
  examSheetId: string;
}

export enum DeleteState {
  SUCCESS = 0,
  ALREADYCONFIGURED = 1,
}